import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Breadcrumbs, Text, Title, WrapperFlex } from '@unimed-fesp/components';

import { format } from 'date-fns';
import produce from 'immer';
import { toast } from 'react-toastify';
import history from '../../services/history';
import { Creators as ArquivoUploadActions } from '../../store/ducks/arquivoUpload';
import { Creators as TasksActions } from '../../store/ducks/task';
// #region Import Componentes
import FadeIn from '../../components/atoms/FadeIn';

// #endregion

import theme from '../../styles/theme';
import { Container } from './styles';

import TableRelatoriosBeneficiario from '../../components/molecules/TableRelatoriosBeneficiario';
import { SuccessToast } from '../../components/molecules/Toast';
import ModalFiltrosAplicados from '../../components/organisms/ModalFiltrosAplicados';
import ModalRelatoriosAcoes from '../../components/organisms/ModalRelatoriosAcoes';
import useSignalR from '../../hooks/useSignalR';
import { downloadFile } from '../../utils/base64';

const ProcessamentoRelatorio = () => {
  const dispatch = useDispatch();
  const [BuildConnection, OpenConnection, CloseConnection] = useSignalR();

  const { usuario } = useSelector((state) => state.auth);
  const { getListaArquivos, getArquivo } = useSelector(
    (state) => state.arquivoUpload
  );

  const parametrosInicialDeRelatorios = {
    codigoContratante: usuario.codigoContratante,
    paginaInicial: 0,
    quantidadeMaximaPorPagina: 10,
  };
  const parametrosDePaginacaoIncial = {
    pageNumber: 1,
    pageSize: 10,
  };

  const [modalInformacoes, setModalInformacoes] = useState({
    isOpen: false,
    taskId: null,
  });
  const [parametrosRelatorios, setRelatoriosParams] = useState(
    parametrosInicialDeRelatorios
  );
  const [parametrosDePaginacao, setParametroDePaginacao] = useState(
    parametrosDePaginacaoIncial
  );

  const [modal, setModal] = useState({
    open: false,
    tipoModal: 'error',
    idTask: '',
    podeReprocessar: null,
  });

  const handleChangePage = (paramsPag) => {
    if (paramsPag.pageNumber <= 0) {
      const novosParametrosDePaginacao = produce(
        parametrosDePaginacao,
        (draft) => {
          draft.pageNumber = 1;
          draft.pageSize = paramsPag.pageSize;
        }
      );
      setParametroDePaginacao(novosParametrosDePaginacao);
    }

    dispatch(
      ArquivoUploadActions.getListaArquivosRequest(
        parametrosRelatorios.codigoContratante,
        paramsPag.pageNumber <= 0 ? 0 : paramsPag.pageNumber - 1,
        paramsPag.pageSize
      )
    );
  };

  const reprocessarTask = (idTask) => {
    dispatch(TasksActions.putReprocessarTaskRequest(idTask));

    return toast.success(
      <SuccessToast>O Reprocessamento será iniciado!</SuccessToast>
    );
  };

  const obterErrosDeTask = (idTask, podeReprocessar) => {
    dispatch(TasksActions.getUltimoErroTaskRequest(idTask));
    setModal({
      open: true,
      tipoModal: 'error',
      idTask,
      podeReprocessar,
    });
  };

  const obterArquivoParaDownload = (idArquivo) => {
    dispatch(ArquivoUploadActions.getArquivoRequest(idArquivo));
    setModal({
      open: true,
      tipoModal: 'download',
    });
  };

  const downloadArquivo = (nomeArquivo, base64) => {
    const extension = nomeArquivo.split('.')[1].toLocaleUpperCase();
    downloadFile(base64, nomeArquivo, extension);
    closeModal();
  };

  const closeModal = () => {
    setModal({
      error: false,
      tipoModal: 'error',
      message: '',
      idTask: null,
      tipoError: 0,
    });
    dispatch(ArquivoUploadActions.getArquivoSuccess(false, false));
  };

  const redirecionarAdministrador = (regra) => {
    if (regra === 'Adm') {
      history.push('/novo/lista');
    }
  };

  const obterListaDeRelatorios = () => {
    dispatch(
      ArquivoUploadActions.getListaArquivosRequest(
        parametrosRelatorios.codigoContratante,
        parametrosRelatorios.paginaInicial,
        parametrosRelatorios.quantidadeMaximaPorPagina
      )
    );
  };

  useEffect(() => {
    redirecionarAdministrador(usuario.role);
    obterListaDeRelatorios();

    const conexao = BuildConnection('TaskStatusChangedHub');
    OpenConnection(conexao);

    conexao.on('TaskStatusChanged', (mensagem) => {
      dispatch(ArquivoUploadActions.getAtualizacaoDeRelatorioRequest(mensagem));
    });

    return () => {
      CloseConnection(conexao);
    };
  }, []);

  return (
    <Container>
      <FadeIn>
        <WrapperFlex justifyStart alignStart column>
          <WrapperFlex fullWidth justifySpaceBetween alignStart>
            <Title
              text="Relatórios"
              color={theme.titleGray}
              fontSize={38}
              marginBottom={8}
            />
          </WrapperFlex>
          <Breadcrumbs
            crumbs={[
              { path: 'novo' },
              {
                path: 'Relatórios',
                onNavigate: () => history.push('/novo/relatorios'),
              },
            ]}
          />
        </WrapperFlex>
        <WrapperFlex column>
          <TableRelatoriosBeneficiario
            openModalInformacoes={setModalInformacoes}
            paginationParams={parametrosDePaginacao}
            setPaginationParams={setParametroDePaginacao}
            handleChangePage={handleChangePage}
            reprocessarTask={reprocessarTask}
            obterErrosDeTask={obterErrosDeTask}
            downloadRelatorio={obterArquivoParaDownload}
          />
        </WrapperFlex>
      </FadeIn>
      <ModalRelatoriosAcoes
        onClick={() => closeModal()}
        isOpen={modal.open}
        idTask={modal.idTask}
        tipoModal={modal.tipoModal}
        downloadArquivo={downloadArquivo}
        podeReprocessar={modal.podeReprocessar}
      />

      <ModalFiltrosAplicados
        modalData={modalInformacoes}
        filtros={getListaArquivos.response.dados}
        closeModal={() => setModalInformacoes({ taskId: null, isOpen: false })}
      />
    </Container>
  );
};

export default ProcessamentoRelatorio;
